import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DistributorService } from '../../../../services/distributor.service';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';
import { Helpers } from '../../../../helpers/helpers';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { StihlDistributorBillingDTO } from 'src/app/models/stihl-distributor-dto';
import { LanguageApp } from 'src/app/config/datatable-config';

@Component({
  selector: 'distributor-billing',
  templateUrl: './distributor-billing.component.html'
})

export class CommonDistributorBillingComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dataform: FormGroup;
  modelData: StihlDistributorBillingDTO = new StihlDistributorBillingDTO();
  isEdit = false;
  showData = false;
  submitted = 0;
  textButton = "Novos dados de faturação";
  listenerFn: () => void;
  constructor(private distributorService: DistributorService, private toastr: ToastrService, private renderer: Renderer2, private helper: Helpers) {
  }

  ngOnInit() {

    this.setDatatable();

    this.dataform = new FormGroup({
      IdDistributorBilling: new FormControl(null),
      IdDistributor: new FormControl(0),
      BillingType: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      Tradename: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      Cif: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      PrincipalContact: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      Address: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      Phone: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      Mail: new FormControl(null, [Validators.required, Validators.maxLength(150)])
    });

  }

  saveEvent() {

    this.submitted = 1;

    if (this.dataform.invalid) return;

    this.modelData = this.dataform.value;

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Aguarde por favor…'
    });
    Swal.showLoading();

    if (!this.isEdit)
      this.postData();
    else
      this.putData();

  }

  postData() {

    this.distributorService.postDistributorBilling(this.modelData).subscribe(resp => {

      this.toastr.success("O registo foi criado com sucesso");
      this.dataform.reset();
      this.dataform.controls['IdDistributor'].setValue(0);
      this.rerender();
      this.showData = false;
      this.submitted = 0;
      this.textButton = "Novos dados de faturação";
      Swal.close();

    }, (err) => {

      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar',
        text: 'Ocorreu um erro'
      });
    });
  }

  putData() {

    this.distributorService.putDistributorBilling(this.modelData.IdDistributorBilling, this.modelData).subscribe(resp => {

      this.toastr.success("Os dados foram atualizados com sucesso");
      this.dataform.reset();
      this.dataform.controls['IdDistributor'].setValue(0);
      this.rerender();
      this.showData = false;
      this.submitted = 0;
      this.textButton = "Novos dados de faturação";
      this.isEdit = false;

      Swal.close();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao atualizar',
        text: 'Ocorreu um erro'
      });
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.listenerFn = this.renderer.listen('document', 'click', (event) => {

      if (event.target.hasAttribute("billing-edit-id")) {

        const id = event.target.getAttribute("billing-edit-id");

        this.distributorService.getDistributorBilling(id).subscribe(res => {

          this.modelData = res;
          this.isEdit = true;
          this.modelData = res;
          this.dataform.patchValue(this.modelData);
          this.showData = true;
          this.textButton = "CANCELAR";

        });

      }
      else if (event.target.hasAttribute("billing-delete-id")) {

        const id = event.target.getAttribute("billing-delete-id");
        this.delete(id);

      }

    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }


  setDatatable() {
    const that = this;
    this.dtOptions = {
      ajax: (dataTablesParameters: any, callback) => {

        that.distributorService.getDistributorBillingDataTable(dataTablesParameters).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao recuperar os dados',
            text: 'Ocorreu um erro'
          });

        });
      },
      drawCallback: function () {
        that.helper.enableBsTooltips();
      },
      columns: [

        { data: "TipoFacturacion", orderable: false },
        { data: "NombreComercial", orderable: false },
        { data: "Cif", orderable: false },
        { data: "Contacto", orderable: false },
        { data: "Direccion", orderable: false },
        { data: "Telefono", orderable: false },
        { data: "Mail", orderable: false },
        { data: "Id", orderable: false }

      ],
      columnDefs: [
        {
          targets: [0],
          data: "TipoFacturacion",
        },
        {
          targets: [1],
          data: "NombreComercial",
        },
        {
          targets: [2],
          data: "Cif",
          className: "text-center"
        },
        {
          targets: [3],
          data: "Contacto",
        },
        {
          targets: [4],
          data: "Direccion",
        },
        {
          targets: [5],
          data: "Telefono",
        },
        {
          targets: [6],
          data: "Mail",
        },
        {
          targets: [7],
          data: "Id",
          className: "text-center",
          render: function (data, type, full) {
            var retorno = "";
            retorno += '<div class="cont__btn-option"><button billing-edit-id="' + data + '" class="btn-option btn-option-edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Editar"></button>';
            retorno += '<button billing-delete-id="' + data + '"class="btn-option btn-option-delete" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Eliminar"></button></button></div>';
            return retorno;
          }
        }
      ],
      responsive: false,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      processing: true
    };
  }



  delete(id) {
    Swal.fire({
      title: 'Deseja remover este item?',
      text: "O item irá desaparecer ao administrador",
      icon: 'warning',
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.distributorService.deleteDistributorBilling(id).subscribe(() => {
          this.toastr.success("O item foi removido com sucesso");
          this.dataform.reset();
          this.dataform.controls['IdDistributor'].setValue(0);
          this.rerender();
          this.showData = false;
          this.submitted = 0;
          this.textButton = "Novos dados de faturação";
          this.isEdit = false;
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao eliminar o item',
            text: 'Ocorreu um erro'
          });
        });
      }
    })
  }

  showDataToggle() {

    this.showData = !this.showData;

    if (this.showData) {

      this.textButton = "CANCELAR";

    } else {

      this.textButton = "Novos dados de faturação";
      this.dataform.reset();
      this.submitted = 0;

    }
  }
}
